import { appUtils } from 'src/components';

const getInitialState = () => ({
  status: [],
  teamId: null,
  groupId: null,
  assignees: [],
  levels: [],
  dateKey: 'lastUpdated',
  lastUpdated: appUtils.getDefaultRange(),
  sort: {
    field: 'lastUpdated',
    order: 'desc'
  },
  createdDate: undefined,
  deadline: undefined
});

export default getInitialState;
